<div class="container {{ OBJ_LNG_NAME }} insertEdit">
	<div class="dialog-header">
	<h1 mat-dialog-title>
		{{ (aktuell.id ? 'allgemein.bearbeiten' : 'allgemein.neu') | translate:locale.language:{ typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}
		<mat-progress-bar *ngIf="dataService.isRequestRunning" color="primary" mode="indeterminate"></mat-progress-bar>
	</h1>
	<button class="close-button" mat-icon-button type="button" mat-dialog-close><mat-icon aria-label="Schließen">close</mat-icon></button>
</div>
	<mat-dialog-content>

		<form #inserteditForm="ngForm" class="{{ OBJ_LNG_NAME }} inserteditForm">
			<input matInput [hidden]="true" [(ngModel)]="aktuell.id" name="id" autofocus />
			<input matInput [hidden]="true" [(ngModel)]="aktuell.frageId" name="frageId" />
			<input matInput [hidden]="true" [(ngModel)]="aktuell.fragebogenId" name="fragebogenId" />

			<p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>

			<mat-form-field class="full-width">
				<input matInput #vorname="ngModel" [(ngModel)]="aktuell.vorname" name="vorname"
							maxlength="50" [disabled]="dialogrunningajaxcall" required />
<mat-label>{{ OBJ_LNG_NAME+'.vorname' | translate:locale.language }}</mat-label>
						<mat-hint *ngIf="vorname.errors && (vorname.dirty || vorname.touched) && vorname.errors.required">{{ 'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.vorname' | translate:locale.language } }}</mat-hint>
						<mat-hint *ngIf="vorname.value" align="end">{{ vorname.value.length }} / 100</mat-hint>
			</mat-form-field>

			<mat-form-field class="full-width">
				<input matInput #nachname="ngModel" [(ngModel)]="aktuell.nachname" name="nachname"
							maxlength="50" [disabled]="dialogrunningajaxcall" required />
<mat-label>{{ OBJ_LNG_NAME+'.nachname' | translate:locale.language }}</mat-label>
						<mat-hint *ngIf="nachname.errors && (nachname.dirty || nachname.touched) && nachname.errors.required">{{ 'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.nachname' | translate:locale.language } }}</mat-hint>
						<mat-hint *ngIf="nachname.value" align="end">{{ nachname.value.length }} / 100</mat-hint>
			</mat-form-field>

			 <mat-form-field class="full-width">
				<input matInput #funktion="ngModel" [(ngModel)]="aktuell.funktion" name="funktion"
							maxlength="50" [disabled]="dialogrunningajaxcall" />
<mat-label>{{ OBJ_LNG_NAME+'.funktion' | translate:locale.language }}</mat-label>
						<mat-hint *ngIf="funktion.errors && (funktion.dirty || funktion.touched) && funktion.errors.required">{{ 'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.funktion' | translate:locale.language } }}</mat-hint>
						<mat-hint *ngIf="funktion.value" align="end">{{ funktion.value.length }} / 100</mat-hint>
			</mat-form-field>

			<mat-form-field class="full-width">
				<input matInput #email="ngModel" [(ngModel)]="aktuell.email" name="email"
							maxlength="50" [disabled]="dialogrunningajaxcall" />
<mat-label>{{ OBJ_LNG_NAME+'.email' | translate:locale.language }}</mat-label>
						<mat-hint *ngIf="email.errors && (email.dirty || email.touched) && email.errors.required">{{ 'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.email' | translate:locale.language } }}</mat-hint>
						<mat-hint *ngIf="email.value" align="end">{{ email.value.length }} / 100</mat-hint>
			</mat-form-field>

			<mat-form-field class="full-width">
				<input matInput #telefon="ngModel" [(ngModel)]="aktuell.telefon" name="telefon"
							maxlength="50" [disabled]="dialogrunningajaxcall" />
<mat-label>{{ OBJ_LNG_NAME+'.telefon' | translate:locale.language }}</mat-label>
						<mat-hint *ngIf="telefon.errors && (telefon.dirty || telefon.touched) && telefon.errors.required">{{ 'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.telefon' | translate:locale.language } }}</mat-hint>
						<mat-hint *ngIf="telefon.value" align="end">{{ telefon.value.length }} / 100</mat-hint>
			</mat-form-field>

			<mat-form-field class="full-width">
				<input matInput #fax="ngModel" [(ngModel)]="aktuell.fax" name="fax"
							maxlength="50" [disabled]="dialogrunningajaxcall" />
<mat-label>{{ OBJ_LNG_NAME+'.fax' | translate:locale.language }}</mat-label>
						<mat-hint *ngIf="fax.errors && (fax.dirty || fax.touched) && fax.errors.required">{{ 'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.fax' | translate:locale.language } }}</mat-hint>
						<mat-hint *ngIf="fax.value" align="end">{{ fax.value.length }} / 100</mat-hint>
			</mat-form-field>

			<mat-form-field class="full-width">
				<input matInput #hofberater="ngModel" [(ngModel)]="aktuell.hofberater" name="hofberater"
					   type="number" maxlength="50" [disabled]="dialogrunningajaxcall" />
<mat-label>{{ OBJ_LNG_NAME+'.hofberater' | translate:locale.language }}</mat-label>
						<mat-hint *ngIf="hofberater.errors && (hofberater.dirty || hofberater.touched) && hofberater.errors.required">{{ 'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.hofberater' | translate:locale.language } }}</mat-hint>
						<mat-hint *ngIf="hofberater.value" align="end">{{ hofberater.value.length }} / 100</mat-hint>
			</mat-form-field>

<!--			<mat-card appearance="outlined">-->
<!--				<mat-card-subtitle>-->
<!--					{{ OBJ_LNG_NAME+'.kontaktart' | translate:locale.language }}-->
<!--				</mat-card-subtitle>-->
				<mat-form-field class="full-width">
					<mat-select [(ngModel)]="aktuell.kategorie" [compareWith]="compareMitId"
								name="typCtl"
								class="full-width" [disabled]="dialogrunningajaxcall" required>
						<mat-option *ngFor="let kategorie of aktuell.kategorieListe" [value]="kategorie.id">{{ kategorie.bezeichnung }}</mat-option>
					</mat-select>
					<mat-label>{{ OBJ_LNG_NAME+'.kontaktart' | translate:locale.language }}</mat-label>
				</mat-form-field>
<!--			</mat-card>-->

		</form>
	</mat-dialog-content>

	<mat-dialog-actions align="end">

		<button mat-raised-button type="button" (click)="close()" [disabled]="dialogrunningajaxcall">{{ 'allgemein.abbrechen' | translate:locale.language }}</button>
		<button mat-raised-button type="submit" (click)="speichernAendern()" color="primary" [disabled]="!inserteditForm.form.valid || dialogrunningajaxcall">
			<mat-spinner *ngIf="dialogrunningajaxcall" color="primary" mode="indeterminate"></mat-spinner>
			{{ (dialogrunningajaxcall ? 'allgemein.daten.verarbeiten' : (neu ? 'allgemein.neu' : 'allgemein.speichern')) | translate:locale.language:{ typ: OBJ_LNG_NAME+'.liste' | translate:locale.language } }}
		</button>

	</mat-dialog-actions>
</div>

